var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loadingSpinnerComponent"},[(!_vm.showSpinner)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"loading-spinner",class:_vm.customClass},[_c('i',{staticClass:"fa fa-spin fa-circle-o-notch"}),_vm._v(" "),_vm._t("loading-text")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }